// =======================================
// src/hooks/useDoctorEmailCode.js
// =======================================
import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosDoctorAuth } from "../../api/axios";
import ENDPOINTS from "../../api/endpoints";

const isValidEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || "").trim());

export const useDoctorEmailCode = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const isValid = useMemo(() => isValidEmail(email), [email]);

  const handleChange = (value) => {
    setEmail(value);
    if (error) setError("");
    if (message) setMessage("");
  };

  const handleSendCode = async () => {
    setError("");
    setMessage("");

    const e = String(email || "").trim().toLowerCase();
    if (!e) return setError("Please enter your email address");
    if (!isValidEmail(e)) return setError("Please enter a valid email address");

    setLoading(true);
    try {
      await axiosDoctorAuth.post(
        ENDPOINTS.DOCTOR_AUTH.REQUEST_RESET,
        { email: e },
        { skipAuth: true } // ✅ IMPORTANT (pas de Bearer)
      );

      setMessage("Code sent successfully.");

      // ✅ go to verify page
      navigate("/VerifCode", {
        state: { email: e },
        replace: true,
      });
    } catch (err) {
      const msg =
        err?.message ||
        err?.data?.message ||
        err?.response?.data?.message ||
        "Failed to send code";
      setError(msg);
      console.error("Doctor send code error:", err);
    } finally {
      setLoading(false);
    }
  };

  return {
    email,
    handleChange,
    handleSendCode,
    isValid,
    loading,
    error,
    message,
    setEmail,
    setError,
  };
};
